// Drift-free intersection of IPDB display state shared by the vis
// (`XdaSettingsState`) and map (`IpdbState`) domains. Palette naming
// (`ipdbColor` vs `ipdbColorPaletteName`) is deliberately excluded — see
// docs/state-management/STATE_OWNERSHIP_CONTRACT.md, EVA-6910 section.
export interface IpdbDisplaySettings {
  showIpdb: boolean;
  reverseColor: boolean;
}

export const makeIpdbDisplayDefaults = (): IpdbDisplaySettings => ({
  showIpdb: false,
  reverseColor: false
});
